import React, { useEffect, useRef, useState } from "react";
import { Collapse, makeStyles } from "@material-ui/core";
import SEO from "../../components/SEO";
import { color, motion, transform, useInView } from "framer-motion";
import Link from "../../components/v2/Link";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import clsx from "clsx";

import compareItemImg1 from "../../images/v4/whatsappCatalogue/images/compareItemImg1.webp";
import compareItemImg2 from "../../images/v4/industry/education/images/compareItemImg4.png";
import compareItemImg3 from "../../images/v4/industry/education/images/compareItemImg2.png";
import compareItemImg4 from "../../images/v4/industry/education/images/compareItemImg3.png";
import compareItemImg5 from "../../images/v4/country/canada/images/compareItemImg5.png";

import swiperIcon1 from "../../images/v4/user-based-tools/voipVideoCall/icons/swiperIcon1.svg";
import swiperIcon2 from "../../images/v4/user-based-tools/voipVideoCall/icons/swiperIcon2.svg";
import swiperIcon3 from "../../images/v4/user-based-tools/voipVideoCall/icons/swiperIcon3.svg";
import swiperIcon4 from "../../images/v4/user-based-tools/voipVideoCall/icons/swiperIcon4.svg";

import growingIcon1 from "../../images/v4/user-based-tools/voipVideoCall/icons/growingIcon1.svg";
import growingIcon2 from "../../images/v4/user-based-tools/voipVideoCall/icons/growingIcon2.svg";
import growingIcon3 from "../../images/v4/user-based-tools/voipVideoCall/icons/growingIcon3.svg";
import growingIcon4 from "../../images/v4/user-based-tools/voipVideoCall/icons/growingIcon4.svg";
import growingIcon5 from "../../images/v4/user-based-tools/voipVideoCall/icons/growingIcon5.svg";
import growingIcon6 from "../../images/v4/user-based-tools/voipVideoCall/icons/growingIcon6.svg";
import growingIcon7 from "../../images/v4/user-based-tools/emailIntegration/icons/growingIcon7.svg";

import clientLogo1 from "../../images/v4/salesReps/clientLogo/client1.png";
import clientLogo2 from "../../images/v4/salesReps/clientLogo/client2.png";
import clientLogo3 from "../../images/v4/salesReps/clientLogo/client3.png";
import clientLogo4 from "../../images/v4/salesReps/clientLogo/client4.png";
import clientLogo5 from "../../images/v4/salesReps/clientLogo/client5.png";
import clientLogo6 from "../../images/v4/salesReps/clientLogo/client6.png";
import clientLogo7 from "../../images/v4/salesReps/clientLogo/client7.png";

import leadCaptureIcon from "../../images/v4/industryPage/leadCpature.png";
import quatationIcon from "../../images/v4/industryPage/quatation.png";
import contactManagemntIcon from "../../images/v4/industryPage/contactManagement.png";
import pipelineIcon from "../../images/v4/industryPage/pipeline.png";
import omniChannelIcon from "../../images/v4/industryPage/omnichannel.png";
import emailMarketingIcon from "../../images/v4/industryPage/emailmarketing.png";
import salesForecastIcon from "../../images/v4/industryPage/salesForecast.png";
import opportunityMangeIcon from "../../images/v4/industryPage/opportunityManagement.png";
import aiChatbotIcon from "../../images/v4/industryPage/aiChatbot.png";
import whatsappCrmIcon from "../../images/v4/industryPage/whatsappCrm.png";
import mobileCrmIcon from "../../images/v4/industryPage/mobileCrm.png";
import utmTrackingIcon from "../../images/v4/industryPage/utmTracking.png";
import realTimeDashboardIcon from "../../images/v4/industryPage/realTimeDashboard.png";
import voipToolIcon from "../../images/v4/industryPage/voipTool.png";
import videoConferencingIcon from "../../images/v4/industryPage/videoConference.png";

import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";

import benefitSectionBg from "../../images/v4/user-based-tools/emailIntegration/images/benefitSectionBg.png";
import flipSectionBg from "../../images/v4/user-based-tools/emailIntegration/images/flipSectionBg.png";
import heroSectionBg from "../../images/v4/user-based-tools/voipVideoCall/images/heroSectionBg.png";
import heroSectionImg from "../../images/v4/user-based-tools/voipVideoCall/images/heroSectionImg.webp";
import swiperCardBg from "../../images/v4/user-based-tools/emailIntegration/images/swiperCardBg.png";
import combineSectionBg from "../../images/v4/user-based-tools/messagingCommunication/images/combineSectionBg.png";
import compareBg from "../../images/v4/user-based-tools/messagingCommunication/images/compareBg.png";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import ClientScroll from "../../components/v4/clientScroll/ClientScroll";

import flipImg1 from "../../images/v4/user-based-tools/voipVideoCall/images/flipImg2.webp";
import flipImg2 from "../../images/v4/user-based-tools/voipVideoCall/images/flipImg1.webp";
import flipImg3 from "../../images/v4/user-based-tools/voipVideoCall/images/flipImg3.webp";

import tabIcon1 from "../../images/v4/user-based-tools/voipVideoCall/icons/tabIcon1.svg";
import tabIcon2 from "../../images/v4/user-based-tools/voipVideoCall/icons/tabIcon2.svg";
import tabIcon3 from "../../images/v4/user-based-tools/voipVideoCall/icons/tabIcon3.svg";

import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";

const useStyles = makeStyles((theme) => ({
  whatsappSection: {
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    padding: "60px 0",
    backgroundImage: `url(${heroSectionBg})`,
    "& $aiSectionLeft": {
      width: "53%",
      gap: "25px",
    },
    "& .countryHighlight": {
      background: "linear-gradient(90deg, #25D366 0%, #0D4D85 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "& .buttonContaienr": {
      marginTop: "20px",
    },
    "& .container": {
      paddingBottom: "40px",
    },

    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      marginTop: "70px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "0",
      backgroundPosition: "bottom",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      "& $aiSectionLeft": {
        width: "100%",
        gap: "16px",
        "&  .wpLogo": {
          width: "40px",
          height: "40px",
          position: "relative",
          top: "10px",
        },
      },
      paddingTop: "0px",
      "& .centerContainer": {
        width: "100%",
        marginTop: "30px",
      },
      "& .container": {
        paddingBottom: "20px",
      },
      "& .buttonContaienr": {
        marginTop: "10px",
      },
    },
  },
  aiSectionContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  aiSectionLeft: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "40%",
    gap: "20px",
    "& .highlighterText": {
      background: "linear-gradient(90deg, #7AFFAB 0%, #80C8FF 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    // "&  .wpLogo": {
    //   width: "40px",
    //   height: "40px",
    //   position: "relative",
    //   top: "10px",
    // },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  aiSectionRight: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  listContainer: {
    display: "flex",
    marginTop: "16px",
    width: "100%",
    flexWrap: "wrap",
    // flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      minWidth: "100%",
      gap: "8px",
      marginTop: "0",
    },
  },
  listItem: {
    background: "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    border: "1px solid rgba(241, 223, 255, 0.40)",
    borderRadius: "50px",
    padding: "10px 15px",
    minWidth: "max-content",
    "@media only screen and (max-width: 600px)": {},
    // color: "#A2BED3",
  },
  flipSection: {
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${flipSectionBg})`,
    "& .centerContainer": {
      width: "80%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      margin: "0 auto",
      textAlign: "center",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .stackWrapper": {
      height: "700px",
      marginTop: "20px",
      "@media only screen and (max-width: 600px)": {
        height: "1080px",
        marginTop: "20px",
      },
    },
  },
  tabs: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "48px 0",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      gap: "20px",
      overflow: "auto",
    },
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  flipTopHeader: {
    width: "80%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    margin: "0 auto",
    textAlign: "center",
  },
  tab: {
    cursor: "pointer",
    gap: "10px",
    width: "32%",
    display: "flex",
    justifyContent: "center",
    padding: "20px 20px",
    alignItems: "center",
    borderRadius: "60px",
    transition: "0.3s ease",
    border: "1px solid #C8D3E0",
    "&.active": {
      background: "#FF682A",
      border: "1px solid #FF682A",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "16px 20px",
    },
  },
  flipCard: {
    background: "#fff",
    borderRadius: "24px",
    overflow: "hidden",
    display: "flex",
    width: "100%",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  flipCardLeft: {
    width: "50%",
    paddingTop: "40px",
    display: "flex",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      paddingTop: "0px",
    },
  },
  flipCardRight: {
    padding: "40px",
    width: "50%",
    display: "flex",
    flexDirection: "column",
    gap: "40px",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "20px",
      gap: "20px",
    },
  },
  flipCardRightHeader: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
  },
  flipCardPointers: {
    display: "flex",
    gap: "40px",
    flexWrap: "wrap",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
  },
  flipCardPointer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "45%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  growingBusiness: {
    // backgroundImage: `url(${growingBussinessBg})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingBottom: "80px",
    position: "relative",
    "& .header": {
      width: "80%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
      gap: "32px",
    },
    "& $featureContainer": {
      gap: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "50px",
      "& .header": {
        width: "100%",
      },
    },
  },
  broadcastContainerInner: {
    gap: "30px",
    width: "100%",
    display: "flex",
    padding: "0 16rem 0rem 16rem",
    paddingBottom: "10px !important",
    alignItems: "stretch",
    justifyContent: "flex-start",
    "& swiper-wrapper": {
      alignItems: "stretch !important",
    },

    "& $featureContainer": {
      width: "31%",
      height: "auto  !important",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "0 15px !important",
      paddingBottom: "10px !important",
    },
    "@media only screen and (min-width: 1400px)": {
      paddingLeft: "8rem !important",
      paddingRight: "8rem !important",
    },
    "@media only screen and (min-width: 1700px)": {
      paddingLeft: "16rem !important",
      paddingRight: "16rem !important",
    },
    "@media only screen and (min-width: 1900px)": {
      paddingLeft: "20rem !important",
      paddingRight: "20rem !important",
    },
  },
  featureContainer: {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "32%",
    gap: "22px",
    boxShadow: "0px 0px 16px #C1D7DB66",
    borderRadius: "16px",
    background: "#fff",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    textAlign: "left",
    "& p": {
      width: "90%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& p": {
        width: "100%",
      },
    },
  },
  detailSection: {
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${benefitSectionBg})`,
    // "&.section3": {
    //   background: "linear-gradient(180deg, #001742 0%, #002C7E 100%)",
    // },
    // "&.section1": {
    //   background: "transparent",
    // },
  },
  detailCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column-reverse",
      gap: "20px",
    },
    "&.detailCard3": {
      "@media only screen and (max-width: 600px)": {
        flexDirection: "column-reverse",
        gap: "32px",
      },
    },
  },
  detailCardLeft: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "20px",
    width: "auto",
    "&.card2": {
      width: "48%",
      backgroundRepeat: "no-repeat",
      backgroundImage: `url(${swiperCardBg})`,
      backgroundSize: "contain",
      backgroundPosition: "top",
      padding: "20px 20px 0",
      flexWrap: "wrap",
      flexDirection: "row",
      borderRadius: "16px 16px 0 0",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "&.card2": {
        width: "100%",
        padding: "0",
        alignItems: "stretch",
        backgroundImage: "none",
        gap: "15px",
        marginTop: "24px",
      },
    },
  },
  detailCardRight: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "20px",
    width: "48%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  swiperCard: {
    background: "#fff",
    boxShadow: "0 4px 26.1px 0 #F5C5B9",
    width: "48%",
    padding: "32px 24px",
    borderRadius: "16px",
    height: "250px",
    overflow: "hidden",
    transition: "0.5s ease",
     "@media only screen and (max-width: 600px)": {
       boxShadow:'2px 2px 16px 0px #F5C5B9'
     },
    "& .mainCard": {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      flexDirection: "column",
      gap: "24px",
      position: "relative",
      "@media only screen and (max-width: 600px)": {
        gap: "15px",
        justifyContent: "flex-start",
      },
    },
    "& .mainCardHeader": {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      width: "100%",
      gap: "16px",
      "@media only screen and (max-width: 600px)": {
        flexDirection: "column",
        alignItems: "flex-start",
      },
    },
    "& .hoverCard": {
      bottom: "-50%",
      height: "-webkit-fill-available",
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      position: "relative",
      transition: "0.5s ease",
      visibility: "hidden",
      opacity: "0",
      "@media only screen and (max-width: 600px)": {
        display: "none",
      },
    },
    // "&:hover": {
    //   "& .mainCard": {
    //     top: "-150%",
    //     visibility: "hidden",
    //     opacity: "0",
    //   },
    //   "& .hoverCard": {
    //     bottom: "100%",
    //     visibility: "visible",
    //     opacity: "1",
    //   },
    // },
    "@media only screen and (max-width: 600px)": {
      width: "47%",
      height: "auto",
      padding: "15px",
      "&:hover": {
        "& .hoverCard": {
          display: "none !important",
        },
        "& .mainCard": {
          top: "0% !important",
          visibility: "visible !important",
          opacity: "1 !important",
        },
      },
    },
  },
  combineSection: {
    position: "relative",
    paddingTop: "64px",
    backgroundImage: `url(${combineSectionBg})`,
    backgroundSize: "cover",
    paddingBottom: "220px",
    "@media(max-width:600px)": {
      paddingBottom: "90px",
    },
  },
  integrationContent: {
    width: "100%",
    textAlign: "center",
    color: "#fff",
    maxWidth: "1200px",
    margin: "0 auto 32px",

    "& h2": {
      marginBottom: "16px !important",
      marginTop: "0 !important",
    },
    "& p": {
      marginBottom: "16px",
      textAlign: "left",
      paddingRight: "80px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& p": {
        paddingRight: "40px",
        fontSize: "18px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& p": {
        paddingRight: "0",
        textAlign: "center",
        fontSize: "16px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginBottom: "20px",
      "& p": {
        fontSize: "14px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& p": {
        fontSize: "13px",
      },
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "100%",
    transform: "translate(-50% ,-50%)",
    left: "50%",
    right: "0",
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 1024px)": {
      width: "35%",
      top: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "12px 16px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "10px 14px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "8px 12px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "6px 10px",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 1024px)": {
      width: "65%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
    "@media only screen and (max-width: 1024px)": {
      marginBottom: "50px",
      gap: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "40px",
      gap: "16px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "30px",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      marginBottom: "25px",
      gap: "12px",
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "12px",
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      marginTop: "15px",
    },
  },
  topFiveHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  faqHeading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
      gap: "10px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  collapseBody: {
    margin: "0",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0  ",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },

  faqBoxAccordian: {
    padding: "0 16px",
    backgroundColor: "transparent",
    borderRadius: "16px",
    position: "relative",
    transition: "all 0.3s ease",
    cursor: "pointer",
    "& h3": {
      color: "#0A2035",
      opacity: "0.7",
    },
    "&:after": {
      content: '""',
      position: "absolute",
      left: "0",
      top: "0",
      width: "2px",
      height: "100%",
      background: "rgba(0, 0, 0, 0.30)",
    },
    "&:before": {
      borderRadius: "0 0 4px 4px",
      content: '""',
      position: "absolute",
      background: "linear-gradient(180deg,#B1DBFF 0%, #fff 0%, #0089FF 100% )",
      left: "-1px",
      top: "0",
      width: "4px",
      height: "100%",
      transform: "scaleY(0)",
      transformOrigin: "top",
      zIndex: 1,
    },
    "&.active": {
      "& h3": {
        color: "#0A2035",
        opacity: "1",
      },
      "&:before": {
        animation: "growTimer 10s linear forwards", // Same as JS interval
      },
    },
    "& .body": {
      margin: "0",
    },
    "& .exp-desc": {
      margin: "10px 0 16px",
    },
  },
  wpFaq: {
    // paddingTop: "120px",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  commonPageFooterSection: {
    background:
      "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  compareSection: {
    backgroundImage: `url(${compareBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundPosition: "top",
    paddingTop: "280px",
    "@media only screen and (max-width: 600px)": {
      paddingTop: "160px",
    },
  },
}));

const VoipAndVideoCall = () => {
  const classes = useStyles();
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeCompare, setActiveCompare] = useState("#section0");
  const [activeAccordian, setActiveAccordian] = useState(0);
  const AUTO_PLAY_INTERVAL = 10000;
  const sectionRef = useRef(null);
  const { ref, inView } = useInView({
    threshold: 0.5, // adjust as needed
    triggerOnce: false,
  });
  const allIcons = [
    {
      img: leadCaptureIcon,
      title: "Auto lead capture",
    },
    {
      img: contactManagemntIcon,
      title: "Contact management",
    },
    {
      img: pipelineIcon,
      title: "Pipeline management",
    },
    {
      img: omniChannelIcon,
      title: "Omnichannel CRM",
    },
    {
      img: emailMarketingIcon,
      title: "Email marketing",
    },
    {
      img: quatationIcon,
      title: "Quotation generation",
    },
    {
      img: salesForecastIcon,
      title: "Sales forecasting",
    },
    {
      img: opportunityMangeIcon,
      title: "Opportunity management",
    },
    {
      img: aiChatbotIcon,
      title: "AI chatbot",
    },
    {
      img: whatsappCrmIcon,
      title: "WhatsApp CRM",
    },
    {
      img: mobileCrmIcon,
      title: "Mobile CRM",
    },
    {
      img: utmTrackingIcon,
      title: "UTM tracking",
    },
    {
      img: realTimeDashboardIcon,
      title: "Real-time dashboard",
    },
    {
      img: voipToolIcon,
      title: "VOIP tool integration",
    },
    {
      img: videoConferencingIcon,
      title: "Video conferencing",
    },
  ];

  // Function to distribute icons across three tracks
  function distributeIcons(icons) {
    // Sort icons alphabetically to ensure consistent distribution
    const sortedIcons = [...icons].sort((a, b) =>
      a.title.localeCompare(b.title)
    );

    const logotrack1 = [];
    const logotrack2 = [];

    sortedIcons.forEach((icon, index) => {
      // Distribute icons based on their index
      switch (index % 2) {
        case 0:
          logotrack1.push(icon);
          break;
        case 1:
          logotrack2.push(icon);
          break;
      }
    });

    return {
      logotrack1,
      logotrack2,
    };
  }

  // Get the distributed icons
  const { logotrack1, logotrack2 } = distributeIcons(allIcons);

  useEffect(() => {
    // Infinite scroll functionality

    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".logos-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "left";
        this.init();
      }

      init() {
        // Clone the track content
        const content = this.track?.innerHTML;
        this.track.innerHTML = content + content + content;

        // Calculate total width
        const logos = this.track.querySelectorAll(".logo-2");
        let totalWidth = 0;
        logos.forEach((logo) => {
          totalWidth +=
            logo.offsetWidth +
            parseInt(getComputedStyle(logo).marginLeft) +
            parseInt(getComputedStyle(logo).marginRight);
        });

        // Set row height
        this.row.style.height = logos[0].offsetHeight + 20 + "px";

        // Set initial position for right-to-left movement
        if (this.direction === "left") {
          this.position = 0;
        } else {
          this.position = -this.track.offsetWidth / 3;
        }

        // Start animation
        this.animate();
      }

      animate() {
        const animate = () => {
          // Update position based on direction
          if (this.direction === "left") {
            this.position -= this.speed;
            // Reset position when one-third of content has scrolled
            const oneThirdWidth = -this.track.offsetWidth / 3;
            if (this.position <= oneThirdWidth) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            // Reset position when one-third of content has scrolled
            if (this.position >= 0) {
              this.position = -this.track.offsetWidth / 3;
            }
          }

          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
      }
    }

    // Initialize all rows with different speeds and directions
    document.querySelectorAll(".logos-row-2").forEach((row) => {
      const speed = parseFloat(row.dataset.speed) || 1;
      new InfiniteScroll(row, speed);
    });
  }, []);

  const compareItems = [
    "Pepper Cloud CRM",
    "Zoho CRM",
    "HubSpot CRM",
    "Salesforce CRM",
    "Freshsales CRM",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud stands out with built-in VoIP calling software, best video calling software integration, and full automation features. From AirCall and KrispCall to Zoom, it brings every tool into one powerful CRM.",
      img: compareItemImg1,
      alt: "Pepper Cloud CRM",
      features: [
        {
          title: "All-in-one communication hub",
          desc: "Manage calls and meetings from one unified CRM dashboard.",
        },
        {
          title: "Zoom integration made easy",
          desc: "Schedule, launch, and log video meetings directly from the CRM.",
        },
        {
          title: "AI-powered call assistance",
          desc: "Automatically suggest next actions, generate call summaries, and highlight key conversation points with built-in AI features.",
        },
        {
          title: "Enhanced call documentation",
          desc: "Add notes, tags, and outcomes to calls, creating a comprehensive history for improved tracking and service continuity.",
        },
        {
          title: "Omnichannel follow-up",
          desc: "Missed a call? Instantly trigger a WhatsApp message via CRM automation to maintain contact and nurture engagement.",
        },
        {
          title: "Real-time engagement tracking",
          desc: "Monitor call outcomes, meeting attendance, and agent performance—updated live within your CRM analytics.",
        },
        {
          title: "Get started",
          desc: "",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Zoho CRM offers native integrations for Zoom and third-party calling tools. It supports video conferencing, call routing, and automated meeting sync within its CRM environment.",
      img: compareItemImg2,
      alt: "Zoho CRM",
      features: [
        {
          title: "Built-in Zoom scheduling",
          desc: "",
        },
        {
          title: "Click-to-call features with plugins",
          desc: "",
        },
        {
          title: "Basic call performance reports",
          desc: "",
        },
      ],
    },
    {
      title: "HubSpot CRM",
      desc: "HubSpot allows integration with Zoom and Aircall via its marketplace. Though not native, it enables basic call tracking, meeting links, and follow-up automation.",
      img: compareItemImg3,
      alt: "HubSpot CRM",
      features: [
        {
          title: "Meeting links in contact timelines",
          desc: "",
        },
        {
          title: "Call activity logging via integrations",
          desc: "",
        },
        {
          title: "Limited call routing functionality",
          desc: "",
        },
      ],
    },
    {
      title: "Salesforce CRM",
      desc: "Salesforce supports Zoom and various cloud telephony platforms via AppExchange. It's well-suited for enterprises seeking scalable, customised voice/video solutions.",
      img: compareItemImg4,
      alt: "Salesforce CRM",
      features: [
        {
          title: "Advanced video call automation",
          desc: "",
        },
        {
          title: "Third-party VoIP flexibility",
          desc: "",
        },
        {
          title: "Deep reporting and dashboards",
          desc: "",
        },
      ],
    },
    {
      title: "Freshsales CRM",
      desc: "Freshsales supports integrations with Zoom, Aircall, and other VoIP tools. It enables basic call logging, meeting sync, and CRM linking for mid-sized businesses.",
      img: compareItemImg5,
      alt: "Freshsales CRM",
      features: [
        {
          title: "Zoom meetings within deals",
          desc: "",
        },
        {
          title: "VoIP logs in contact profiles",
          desc: "",
        },
        {
          title: "Custom workflows and reminders",
          desc: "",
        },
      ],
    },
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  const faqs = [
    {
      question: "Can I call from within the CRM?",
      answer: (
        <>
          Yes, Aircall and KrispCall enable click‑to‑call and receive
          functionality directly in Pepper Cloud.
        </>
      ),
    },
    {
      question: "Are calls and meetings logged automatically?",
      answer: (
        <>
          Yes, all voice calls and Zoom meetings are recorded and saved in
          contact records without manual effort.
        </>
      ),
    },
    {
      question: "Can I host and schedule Zoom meetings from the CRM?",
      answer: (
        <>
          Yes, you can schedule, launch, and manage Zoom meetings directly
          within the CRM, with auto-sync to your calendar and contacts.
        </>
      ),
    },
    {
      question: "Does the CRM support multiple virtual numbers?",
      answer: (
        <>
          Yes, KrispCall integration allows you to use multiple virtual numbers
          and route calls to different teams or departments as needed.
        </>
      ),
    },
    {
      question: "Is it possible to track meeting attendance and follow-ups?",
      answer: (
        <>
          Yes, Pepper Cloud CRM tracks Zoom meeting participants and enables
          follow-up tasks based on outcomes and discussion notes.
        </>
      ),
    },
    {
      question: "How secure is the call and meeting data?",
      answer: (
        <>
          Absolutely, Pepper Cloud uses end‑to‑end encryption and enterprise
          access controls to protect your communication data.
        </>
      ),
    },
  ];

  const swiperCards = [
    {
      icon: swiperIcon1,
      heading: "Auto call recording",
      contentOne:
        "Save time by auto-recording AirCall and KrispCall calls, documenting conversations seamlessly.",
    },
    {
      icon: swiperIcon2,
      heading: "CRM‑linked meeting",
      contentOne:
        "Schedule Zoom meetings within your CRM—meeting links auto-attach to contacts and deals for seamless tracking.",
    },
    {
      icon: swiperIcon3,
      heading: "Intelligent call routing",
      contentOne:
        "Connect call data with CRM contacts instantly, reducing manual updates and keeping records complete.",
    },
    {
      icon: swiperIcon4,
      heading: "Rich analytics dashboard",
      contentOne:
        "Monitor calls and meetings in CRM dashboards to guide smarter, data-driven decisions.",
    },
  ];

  const growingList = [
    {
      icon: growingIcon1,
      background: "linear-gradient(180deg, #0A2F4F 0%, #2576BB 100%)",
      heading: "Unified communication centre",
      text: "Access calls, meetings, contacts, and follow-ups in one CRM, streamlining processes and reducing scattered tools completely.",
    },
    {
      icon: growingIcon2,
      background: "linear-gradient(180deg, #783CA8 0%, #31114B 100%)",
      heading: "Seamless two-way sync",
      text: "Sync calls, contacts, meetings, recordings across platforms, keeping CRM data updated without manual effort.",
    },
    {
      icon: growingIcon3,
      background: "linear-gradient(180deg, #014957 0%, #028BA6 100%)",
      heading: "Automated follow-ups",
      text: "Trigger reminders, tasks, deal updates automatically post-call or meeting, reducing errors and speeding customer engagement.",
    },
    {
      icon: growingIcon4,
      background: "linear-gradient(180deg, #09939A 0%, #783CA8 100%)",
      heading: "Enterprise-grade scalability",
      text: "Easily scale teams, virtual numbers, or call volumes without disrupting workflows, perfect for growing business demands.",
    },
    {
      icon: growingIcon5,
      background: "linear-gradient(180deg, #053333 0%, #009A99 100%)",
      heading: "Top-tier security",
      text: "Secure calls, meetings with encryption, audit logs, role-based access, protecting sensitive voice and video data reliably.",
    },
    {
      icon: growingIcon6,
      background: "linear-gradient(180deg, #0A2F4F 0%, #2576BB 100%)",
      heading: "Mobile-optimised functionality",
      text: "Call, meet, track CRM activity anywhere—ideal for hybrid, remote teams needing constant customer connection.",
    },
  ];
  const clientScrollData = {
    title: "Trusted by top brands across industries",
    backgroundImage: "",
    logos: [
      {
        img: clientLogo1,
      },
      {
        img: clientLogo2,
      },
      {
        img: clientLogo3,
      },
      {
        img: clientLogo4,
      },
      {
        img: clientLogo5,
      },
      {
        img: clientLogo6,
      },
      {
        img: clientLogo7,
      },
    ],
    directions: ["left", "right", "left"],
    speeds: [0.8, 0.4, 0.8],
  };
  const flipCards = [
    {
      tab: "Aircall integration",
      icon: tabIcon1,
      img: flipImg1,
      alt: "Reliable VoIP phone call software",
      heading: "Aircall CRM integration",
      desc: "Unify Aircall with Pepper Cloud CRM to place calls, log recordings automatically, track metrics, and analyse team performance effortlessly from one platform.",
      points: [
        {
          heading: "Call inside CRM",
          desc: "Place calls from CRM records with Aircall’s dialler, reducing clicks and improving sales focus.",
        },
        {
          heading: "Auto tag logs",
          desc: "Tag calls to records automatically, ensuring teams never miss conversation history.",
        },
        {
          heading: "Analyse call metrics",
          desc: "View call durations and outcomes in dashboards to optimise team performance.",
        },
        {
          heading: "Capture call notes",
          desc: "Add detailed call notes instantly to maintain clear customer engagement records.",
        },
      ],
    },
    {
      tab: "KrispCall integration",
      icon: tabIcon2,
      img: flipImg2,
      alt: "Outbound calling software for sales",
      heading: "KrispCall CRM integration",
      desc: "Scale global communications using KrispCall’s cloud telephony. Manage virtual numbers, route calls smartly, store recordings, all seamlessly synced within your CRM.",
      points: [
        {
          heading: "Use virtual numbers",
          desc: "Assign local, toll-free, or international numbers to easily connect with global customers.",
        },
        {
          heading: "Store call recordings",
          desc: "Automatically save all call recordings in CRM for secure, complete interaction history.",
        },
        {
          heading: "Track performance metrics",
          desc: "Analyse call durations, outcomes, and trends to improve team efficiency reliably.",
        },
        {
          heading: "Automate follow-ups",
          desc: "Trigger reminders or WhatsApp follow-ups after calls to enhance engagement.",
        },
      ],
    },
    {
      tab: "Zoom integration",
      icon: tabIcon3,
      img: flipImg3,
      alt: "Efficient outbound call management tools",
      heading: "Zoom CRM integration",
      desc: "Streamline meetings with Zoom integrated into Pepper Cloud. Schedule, join, and log video calls effortlessly, maintaining complete records directly inside your CRM.",
      points: [
        {
          heading: "Manage meetings easily",
          desc: "Schedule, edit, and update Zoom meetings directly inside your CRM platform.",
        },
        {
          heading: "Auto activity tracking",
          desc: "Automatically log meeting details in CRM activities to maintain complete histories.",
        },
        {
          heading: "One-click join",
          desc: "Join Zoom meetings instantly from CRM, boosting productivity and client engagement.",
        },
        {
          heading: "Integrated email invites",
          desc: "Send Zoom links to attendees through CRM emails for seamless scheduling.",
        },
      ],
    },
  ];
  /* Tweak these constants if you want a stronger/weaker stack effect */
  const STACK_SPACING_PX = 30;
  const SCALE_STEP = 0.02;
  const MAX_SCALE_REDUCTION = 0.08;

  const getOpacity = (offset) => {
    if (offset === 0) return 1;
    if (Math.abs(offset) === 1) return 0.6;
    return 0.4;
  };

  const getZIndex = (offset) => {
    // max z-index = 10
    return 10 - Math.abs(offset);
  };
  return (
    <main>
      <SEO
        title={"VoIP & Video Call CRM Integration | Pepper Cloud"}
        pathname={
          "https://peppercloud.com/user-based-tools/crm-calling-software-integration/"
        }
        keywords="Gmail integration, Outlook integration, best CRM for Office 365, CRM chrome extension, email integration, crm system integration"
        description={
          "Connect voice and video tools like Aircall and Zoom with Pepper Cloud CRM. Automate call logging, sync meetings, and drive smarter customer conversations."
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        scripts={[`gtag('event', 'whatsapp_support_crm_generate_lead', {});`]}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "Can I call from within the CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, Aircall and KrispCall enable click-to-call and receive functionality directly in Pepper Cloud.",
                },
              },
              {
                "@type": "Question",
                name: "Are calls and meetings logged automatically?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, all voice calls and Zoom meetings are recorded and saved in contact records without manual effort.",
                },
              },
              {
                "@type": "Question",
                name: "Can I host and schedule Zoom meetings from the CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, you can schedule, launch, and manage Zoom meetings directly within the CRM, with auto-sync to your calendar and contacts.",
                },
              },
              {
                "@type": "Question",
                name: "Does the CRM support multiple virtual numbers?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, KrispCall integration allows you to use multiple virtual numbers and route calls to different teams or departments as needed.",
                },
              },
              {
                "@type": "Question",
                name: "Is it possible to track meeting attendance and follow-ups?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, Pepper Cloud CRM tracks Zoom meeting participants and enables follow-up tasks based on outcomes and discussion notes.",
                },
              },
              {
                "@type": "Question",
                name: "How secure is the call and meeting data?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Absolutely, Pepper Cloud uses end-to-end encryption and enterprise access controls to protect your communication data.",
                },
              },
            ],
          },
        ]}
      />
      <section className={classes.whatsappSection}>
        <div className="container">
          <div className={classes.aiSectionContainer}>
            <div className={classes.aiSectionLeft}>
              <motion.h1
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-semibold font-64 font-white"
              >
                Streamline with VoIP software
              </motion.h1>
              <motion.p
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-regular font-18 font-white"
              >
                Integrate voice calling and video calling tools with  Pepper
                Cloud CRM. Schedule meetings, communicate better, and automate
                growth.
              </motion.p>
              <div className={classes.listContainer}>
                <motion.div
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className={classes.listItem}
                >
                  <LazyImage
                    source={greenCheckCircle}
                    alt={"VoIP calling software for businesses"}
                    className={classes.pointerImg}
                  />
                  <p className="font-wix-regular font-white  font-18">
                    Make calls
                  </p>
                </motion.div>
                <motion.div
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className={classes.listItem}
                >
                  <LazyImage
                    source={greenCheckCircle}
                    alt={"VoIP calling software for businesses"}
                    className={classes.pointerImg}
                  />
                  <p className="font-wix-regular font-white font-18">
                    Auto-capture
                  </p>
                </motion.div>
                <motion.div
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className={classes.listItem}
                >
                  <LazyImage
                    source={greenCheckCircle}
                    alt={"VoIP calling software for businesses"}
                    className={classes.pointerImg}
                  />
                  <p className="font-wix-regular font-white font-18">
                    Centralise data
                  </p>
                </motion.div>
              </div>
              <div className="buttonContaienr">
                <Link
                  className="primaryButton font-16 font-wix-medium font-white"
                  to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
                >
                  Book a free demo
                </Link>
              </div>
            </div>
            <div className={classes.aiSectionRight}>
              <LazyImage
                source={heroSectionImg}
                width="100%"
                alt="VoIP calling software for businesses"
              />
            </div>
          </div>
        </div>
      </section>
      <ClientScroll
        {...clientScrollData}
        // background={topIndustiesBg}
        darkLayout={false}
      />
      <section className={classes.flipSection}>
        <div className="container">
          <div className="centerContainer">
            <h2 className="font-56 font-wix-medium font-white">
              Seamlessly integrate voice and video calling tools with CRM
            </h2>
            <div className={classes.tabs}>
              {flipCards.map((tab, index) => (
                <div
                  className={clsx(
                    classes.tab,
                    activeIndex === index && "active"
                  )}
                  onClick={() => setActiveIndex(index)}
                >
                  <img src={tab.icon} alt={tab.alt} />
                  <p className="font-20 font-wix-medium font-white">
                    {tab.tab}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div
            className="stackWrapper"
            style={{
              position: "relative",
              width: "100%",
            }}
          >
            {flipCards.map((card, index) => {
              const offset = index - activeIndex;
              const translateY = offset * STACK_SPACING_PX;
              const scale =
                1 -
                Math.min(Math.abs(offset) * SCALE_STEP, MAX_SCALE_REDUCTION);

              return (
                <div
                  key={card.tab}
                  className={classes.flipCard}
                  // apply your original flipCard styles (unchanged) and add absolute + transition + transform via inline
                  style={{
                    position: "absolute",
                    left: "50%",
                    top: 0,
                    transform: `translateX(-50%) translateY(${translateY}px) scale(${scale})`,
                    transition:
                      "transform 0.45s cubic-bezier(.2,.9,.2,1), opacity 0.35s",
                    zIndex: getZIndex(offset),
                    opacity: getOpacity(offset),
                    pointerEvents: index === activeIndex ? "auto" : "none",
                  }}
                  aria-hidden={index === activeIndex ? "false" : "true"}
                >
                  <div className={classes.flipCardLeft}>
                    {/* keep your LazyImage usage */}
                    <LazyImage
                      source={card.img}
                      width={"100%"}
                      alt={card.alt}
                    />
                  </div>

                  <div className={classes.flipCardRight}>
                    <div className={classes.flipCardRightHeader}>
                      <h2
                        className="font-40 font-wix-medium color-black1"
                        style={{ margin: 0 }}
                      >
                        {card.heading}
                      </h2>
                      <p
                        className="font-18 font-wix-medium"
                        style={{ color: "#304358", margin: 0 }}
                      >
                        {card.desc}
                      </p>
                    </div>

                    <div className={classes.flipCardPointers}>
                      {card.points.map((point, idx) => (
                        <div key={idx} className={classes.flipCardPointer}>
                          <p
                            className="font-18 font-wix-semibold color-black1"
                            style={{ margin: 0 }}
                          >
                            {point.heading}
                          </p>
                          <p
                            className="font-16 font-wix-regular color-black1"
                            style={{ margin: 0 }}
                          >
                            {point.desc}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <section className={classes.growingBusiness}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-black1"
            >
              Why Pepper Cloud is the best CRM for voice and video integration?
            </motion.h2>
          </div>
        </div>
        <Swiper
          slidesPerView={3.3}
          // centeredSlides={true}
          spaceBetween={30}
          grabCursor={true}
          loop={false}
          speed={5000}
          modules={[Autoplay]}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          // freeMode={true}
          className={classes.broadcastContainerInner}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: 1.3,
              slidesPerGroup: 1,
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 10,
            },
            // For larger screens (desktop)
            768: {
              slidesPerView: 3.3,
              centeredSlides: false,
              spaceBetween: 30,
              grabCursor: true,
            },
          }}
        >
          {growingList.map((feature) => (
            <SwiperSlide
              className={classes.featureContainer}
              style={{ background: feature.background }}
            >
              <LazyImage
                source={feature.icon}
                alt={"WhatsApp CRM for customer service"}
                className={classes.featureIcon}
                // alt={listItem.alt}
              />
              <p className="font-wix-semibold font-24 font-white">
                {feature.heading}
              </p>
              <p className="font-wix-mediu font-18 font-white">
                {feature.text}
              </p>
            </SwiperSlide>
          ))}
        </Swiper>
        {/* <div className={classes.absoulteCard}>
          <TruestedSection background={true} />
        </div> */}
      </section>
      <section className={classes.detailSection}>
        <div className="container">
          <div className={classes.detailCard}>
            <div className={clsx(classes.detailCardLeft, "card2")}>
              {swiperCards.map((card) => (
                <div
                  className={classes.swiperCard}
                  style={{ background: card.gradientOne }}
                >
                  <div className="mainCard">
                    <div className="mainCardHeader">
                      <img src={card.icon} />
                      <h4 className="font-20 color-black1 font-wix-semibold">
                        {card.heading}
                      </h4>
                    </div>
                    <p className="font-16 color-black1 font-wix-regular">
                      {card.contentOne}
                    </p>
                  </div>
                </div>
              ))}
            </div>
            <div className={classes.detailCardRight}>
              <motion.h2
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-semibold font-56 color-black1"
              >
                Benefits of CRM communication integration
              </motion.h2>
              <motion.p
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.3 }}
                className="font-wix-regular font-18 color-black1"
              >
                Unlock CRM communication integration to centralise calls,
                meetings, and data. Boost productivity, automate follow-ups, and
                deliver seamless customer experiences—all within Pepper Cloud’s
                unified platform.
              </motion.p>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.combineSection}>
        <div className={classes.integrationContent}>
          <motion.h2
            className="font-wix-semibold font-56 color-white"
            initial={{ opacity: 1, y: 20 }}
            transition={{ duration: 0.3 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            Pepper Cloud CRM features tailored for business success
          </motion.h2>
        </div>

        <section className="sales-dev-logo-carousel">
          <div className="logos-container">
            <div className="scroll-container">
              <div
                className="logos-row-2"
                data-direction="left"
                data-speed="0.8"
              >
                <div className="logos-track">
                  {logotrack1.map((logo) => (
                    <div
                      className="logo-2 logo font-18 font-wix-medium"
                      key={logo.title}
                    >
                      <img alt={`${logo.title} integration`} src={logo.img} />
                      <p>{logo.title}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div
                className="logos-row-2"
                data-direction="right"
                data-speed="0.4"
              >
                <div className="logos-track">
                  {logotrack2.map((logo) => (
                    <div className="logo-2 logo font-18 font-wix-medium">
                      <img alt={`${logo.title} integration`} src={logo.img} />
                      <p>{logo.title}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className={classes.absoulteCard}>
          <TruestedSection shadow background={true} />
        </div>
      </section>
      <section className={classes.compareSection}>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-semibold font-56 font-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Top 5 CRM software with CRM VoIP calling software
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` &&
                        "font-wix-semibold"
                    )}
                    href={`#section${index}`}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    className="font-40 font-wix-semibold font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.title}
                  </h3>
                  <p
                    className="font-wix-regular font-18 font-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {data.desc}
                  </p>
                  <img alt={data.alt} className="productImage" src={data.img} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                      >
                        <div className={classes.topFiveHeader}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                            src={downArrow}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-wix-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFF8F5"}
          faqs={faqs}
          heading={"VoIP calling software: Frequently asked questions"}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Unlock growth with the best outbound calling software
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=CRM+email+integration&utm_medium=Show+me+how"
            >
              Get started
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default VoipAndVideoCall;
